import React, { useContext } from 'react'

import { LoggedInSmallHeader } from 'components/Header/LoggedIn/Small'
import { LoggedInLargeHeader } from 'components/Header/LoggedIn/Large'
import { LoggedOutSmallHeader } from 'components/Header/LoggedOut/Small'
import { LoggedOutLargeHeader } from 'components/Header/LoggedOut/Large'
import { AppContext } from 'contexts/AppContext'

export const Header = ({ loggedIn, viewer, show, handleNavClick, showUpgradeCta }) => {
  const { site } = useContext(AppContext)
  const altTag = site?.name
  const largeLogo = site?.fullLogoImageSource
  const smallLogo = site?.fullLogoMobileImageSource
  const startedCta = site?.assets?.startedCta
  const rightNavigationItems = site?.navigation?.footer?.navigation_items
  const siteNavigationItems = site?.navigation?.navigation_items?.navigation_items

  if (loggedIn && viewer) {
    const loggedInNavigationItems = viewer.navigation?.navigation_items
    const title = viewer.drop_down?.title
    const profileLink = viewer.drop_down?.link
    const profileNavigationItems = viewer.drop_down?.navigation_items
    const profileEligibleForUpgrade = !!viewer.profileEligibleForUpgrade
    const isSubscribed = !!viewer.is_subscribed
    const hasListing = !!viewer.has_active_listing
    return (
      <>
        <LoggedInLargeHeader
          altTag={altTag}
          logo={largeLogo}
          loggedInNavigationItems={loggedInNavigationItems}
          title={title}
          profileLink={profileLink}
          profileNavigationItems={profileNavigationItems}
          profileEligibleForUpgrade={profileEligibleForUpgrade}
          isSubscribed={isSubscribed}
          hasListing={hasListing}
          showUpgradeCta={showUpgradeCta}
        />
        <LoggedInSmallHeader
          altTag={altTag}
          logo={smallLogo}
          loggedInNavigationItems={loggedInNavigationItems}
          profileNavigationItems={profileNavigationItems}
          handleNavClick={handleNavClick}
          show={show}
          profileEligibleForUpgrade={profileEligibleForUpgrade}
          isSubscribed={isSubscribed}
          hasListing={hasListing}
          showUpgradeCta={showUpgradeCta}
        />
      </>
    )
  }
  return (
    <>
      <LoggedOutLargeHeader
        altTag={altTag}
        logo={largeLogo}
        siteNavigationItems={siteNavigationItems}
        rightNavigationItems={rightNavigationItems}
        startedCta={startedCta}
      />
      <LoggedOutSmallHeader
        altTag={altTag}
        logo={smallLogo}
        show={show}
        handleNavClick={handleNavClick}
        siteNavigationItems={siteNavigationItems}
        startedCta={startedCta}
      />
    </>
  )
}
